

























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({})
export default class SummaryDisplay extends Vue {
  @Prop() summary!:any
  @Prop({ required: true }) displayOrder:number = 2001

  get testTypeSum ():any {
    var testTypes = this.summary.testTypes
    var str = 'In total we conducted '
    var keys = Object.keys(testTypes)
    keys.forEach(function (testKey:any, index:any) {
      var numTests = testTypes[testKey]
      str += numTests + ' ' + testKey + ' Test' + (numTests > 1 ? 's' : '')
      if (index < keys.length - 1 && keys.length > 2) { // If there's only two items no need for comma
        str += ', '
      }
      if (index === keys.length - 2) { // last item should also get 'and'
        if (keys.length === 2) { // in the case there's just two types theres no comma in between, thus no space
          str += ' and '
        } else {
          str += 'and '
        }
      }
    })
    str += '.'
    return str
  }

  get assetsByType ():any {
    var types = {
      Chart: 0,
      'Audio Recording': 0,
      Video: 0,
      'Open Ended Question Result': 0,
      'Other Asset': 0
    }
    this.summary.assets.forEach(function (asset:any) {
      switch (asset.asset_type) {
        case 'viz':
        case 'viz-slice':
        case 'aud-slice':
          types.Chart++
          break
        case 'textResponses':
          types['Open Ended Question Result']++
          break
        case 'textFrequency':
          types['Open Ended Question Result']++
          break
        case 'audio':
          types['Audio Recording']++
          break
        case 'video':
          types.Video++
          break
        default:
          types['Other Asset']++
          break
      }
    })

    return types
  }

  get preambleString ():any {
    var that = this
    var totalCount = 0
    totalCount += this.summary.questions
    totalCount += this.summary.people
    totalCount += this.summary.prototypes
    totalCount += Object.keys(this.assetsByType).reduce(function (sum:any, val:any) {
      return that.assetsByType[val] + sum
    }, 0)

    if (totalCount > 0) {
      return 'This report includes:'
    }
    return 'This report contains no completed research.'
  }
}
